import { SimpleTestResult } from "interface/interface.inspect";
import { useNavigate } from "react-router-dom";
import {
  InspectHomeRecentlyRecordWrapper,
  InspectListItemsWrapper,
  NoData,
} from "style/inspect";
import { getResultImageByType, getReultTypeTitle } from "utils/inspect.util";
import { formatDateTime } from "utils/util";

interface DataProps {
  data: SimpleTestResult[];
}

const InspectListItems = ({ data }: DataProps) => {
  const navigate = useNavigate();

  return (
    <InspectListItemsWrapper>
      {data && data.length > 0 ? (
        data.map((item, index) => (
          <div
            key={index}
            className="itme-wrapper"
            onClick={() => {
              navigate(`/inspect/simple/result/preview/detail/${item.type}`, {
                state: { from: "inspectList" }, // ← 추가된 부분
              });
            }}
          >
            <div className="title">
              <p>{formatDateTime(item.regDt)}</p>
              <span>간이 검사</span>
            </div>
            <div className="contents-box">
              <div className="img-box">
                <img src={getResultImageByType(item.type)} alt="측정 결과" />
              </div>
              <div className="result-type">
                <p>나의 층간소음 유형은</p>
                <h4>{getReultTypeTitle(item.type)}</h4>
              </div>
            </div>
          </div>
        ))
      ) : (
        <NoData>
          <p>검사 결과가 없습니다.</p>
        </NoData>
      )}
    </InspectListItemsWrapper>
  );
};

export default InspectListItems;
